import { InjectionToken } from '@angular/core';

// Dependency injection tokens for the API service

export const API_BASE_URL = new InjectionToken<string>('API_BASE_URL');

